module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 46300.75f26366.png";